export const fileExtensionRegexp: RegExp = new RegExp(/\.[^.]+$/);
